import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const sin: AnswerPathTreeNode = { path: 'sin', nodeId: NodeIds.insuredSIN };
